import styled, { css } from 'styled-components';
import {
  Button as ButtonLayoutComponent,
  Text as TextLayoutComponent, Loader as LoaderLayoutComponent,
} from '@playbookux/playbook-web-core';

const Container = styled.div`
  display: block;
  margin-left: auto;
  margin-right: auto;
  padding-top: 80px;
  max-width: 600px;
  padding-bottom: 10px;
  width: auto;
`;

export const ContainerLoader = styled.div`
  display: flex;
  justify-content: center;
  padding-top: 80px;
`;

const Loader = styled(LoaderLayoutComponent)`
`;

const Content = styled.div`
  width: 100%;
  border: 1px solid #E0E0E0;
  padding: 30px;
  padding-bottom: 0;
  display: flex;
  flex-direction: column;
  border-radius: 2px;
`;

const Heading = styled(TextLayoutComponent.Header)`
  font-size: 18px;
  margin: 0 25px;
  text-align: center;
`;

const SubHeading = styled(TextLayoutComponent)`
  color: ${(props) => props.theme.color.textSecondary};
  font-size: 13px;
  margin: 10px 0;
  text-align: center;
`;

const DataContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;

  margin-bottom: 15px;

  ${(props) => !props.last && css`
  border-bottom: 1px solid ${props.theme.color.buttonInvertedActive};
  `}
`;

const DataLabel = styled.p`
  width: 50%;
  font-weight: 500;
  color: ${(props) => props.theme.color.textLabel};
`;

const DataValue = styled.p`
  width: 50%;
  color: ${(props) => props.theme.color.textSecondary};
`;

const EditButton = styled(ButtonLayoutComponent)``;

const ButtonContainer = styled.div`
  display: flex;
  flex-direction: row-reverse;
  width: 100%;
  margin-bottom: 15px;
`;

const DisabledButton = styled(ButtonLayoutComponent)`
  opacity: .45;
  pointer-events: auto;
`;

export {
  Container,
  Content,
  DataValue,
  DataLabel,
  DataContainer,
  SubHeading,
  Heading,
  EditButton,
  ButtonContainer,
  Loader,
  DisabledButton,
};
